// Generated types for Answer
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { ScopedNodeReadAPI, ScopedNodeWriteAPI } from '../../shared/types/scopednode';
import { ScopedNodeReadAPISchemaObject, ScopedNodeWriteAPISchemaObject } from '../../shared/types/scopednode';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface AnswerReadAPI extends ScopedNodeReadAPI {
  /** The answer value as structured JSON. Shape depends on question type. */
  value?: unknown | null;
}

export interface AnswerWriteAPI extends ScopedNodeWriteAPI {
  /** The answer value as structured JSON. Shape depends on question type. */
  value?: unknown | null;
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const AnswerReadAPISchema: z.ZodType<AnswerReadAPI> = ScopedNodeReadAPISchemaObject.extend({
  value: z.preprocess((v) => typeof v === 'string' ? (() => { try { return JSON.parse(v); } catch { return v; } })() : v, z.unknown().nullable()).optional(),
}).passthrough();

export const AnswerWriteAPISchema: z.ZodType<AnswerWriteAPI> = ScopedNodeWriteAPISchemaObject.extend({
  value: z.preprocess((v) => typeof v === 'string' ? (() => { try { return JSON.parse(v); } catch { return v; } })() : v, z.unknown().nullable()).optional(),
}).passthrough();
